import { render, staticRenderFns } from "./list_config_add_ship.vue?vue&type=template&id=64dfd03e"
import script from "./list_config_add_ship.vue?vue&type=script&lang=js"
export * from "./list_config_add_ship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64dfd03e')) {
      api.createRecord('64dfd03e', component.options)
    } else {
      api.reload('64dfd03e', component.options)
    }
    module.hot.accept("./list_config_add_ship.vue?vue&type=template&id=64dfd03e", function () {
      api.rerender('64dfd03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/list_config_add_ship.vue"
export default component.exports